var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFullCircleIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6048_26219)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.4498 0.5C13.8821 0.52784 0.472203 13.9815 0.500043 30.5492C0.527883 47.1179 13.9815 60.5268 30.5493 60.499C47.118 60.4712 60.5269 47.0175 60.499 30.4498C60.4722 13.9208 47.0792 0.52784 30.5493 0.5H30.4498ZM30.4498 9.07171C42.2848 9.09955 51.8557 18.7153 51.8289 30.5502C51.8011 42.3852 42.1854 51.9561 30.3504 51.9293C18.5164 51.9004 8.94449 42.2847 8.97233 30.4498C8.99917 18.6546 18.5552 9.09856 30.3504 9.07171H30.4498Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4508 43.3567C37.5516 43.3567 43.3079 37.6004 43.3079 30.4997C43.3079 23.3989 37.5516 17.6426 30.4508 17.6426C23.3501 17.6426 17.5938 23.3989 17.5938 30.4997C17.5938 37.6004 23.3501 43.3567 30.4508 43.3567Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6048_26219"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullCircleIcon);
export default __webpack_public_path__ + "static/media/full-circle-icon.88d895f7d42d76c64deda869aabd421c.svg";
export { ForwardRef as ReactComponent };